<div class="container container-shadow py-5 mt-3 mb-5">
  <h3>{{ tax.id ? 'Editing' : 'New' }} Tax</h3>
  <hr />
  <form #currentForm="ngForm" novalidate>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-3 col-md-2">
            <label>Type</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" (change)="typeChanged()" name="type" [(ngModel)]="tax.type">
              <option *ngFor="let type of formOptions.types" [value]="type.value">{{ type.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Chart of Account</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="chart_of_account_id" [(ngModel)]="tax.chart_of_account_id">
              <option *ngFor="let chart_of_account of formOptions.chart_of_accounts" [value]="chart_of_account.value">{{ chart_of_account.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Amount</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" name="amount" [(ngModel)]="tax.amount" class="form-control" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>User Field</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="text" name="user_field" [(ngModel)]="tax.user_field" class="form-control" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Cutoff</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" class="form-control" name="cutoff" [(ngModel)]="tax.cutoff" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Above</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" name="above" [(ngModel)]="tax.above" class="form-control" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Frequency</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="frequency" [(ngModel)]="tax.frequency">
              <option *ngFor="let frequency of formOptions.frequencies" [value]="frequency.value">{{ frequency.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Way</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="way" [(ngModel)]="tax.way">
              <option *ngFor="let way of formOptions.ways" [value]="way.value">{{ way.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Use Global Tax Settings</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <select class="form-control" name="global_tax_id" [(ngModel)]="tax.global_tax_id">
              <option *ngFor="let global_tax of formOptions.global_taxes" [value]="global_tax.value">{{ global_tax.label }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Pay To</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <app-contact-search [contactId]="tax.contact_id" (contact_id)="tax.contact_id = $event"></app-contact-search>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2"></div>
          <div class="col-sm-8 col-md-6">
            <div class="custom-control custom-checkbox" (click)="tax.is_federal = !tax.is_federal">
              <input type="checkbox" name='is_federal' class="custom-control-input" [(ngModel)]="tax.is_federal" [checked]="tax.is_federal" />
              <label class="custom-control-label">Federal?</label>
            </div>
            <br />
            <div class="custom-control custom-checkbox" (click)="tax.is_auto_pay = !tax.is_auto_pay">
              <input type="checkbox" name="is_auto_pay" class="custom-control-input" [(ngModel)]="tax.is_auto_pay" [checked]="tax.is_auto_pay" />
              <label class="custom-control-label">Auto Pay</label>
            </div>
            <br />
            <div class="custom-control custom-checkbox" (click)="tax.is_direct_withdrawal = !tax.is_direct_withdrawal">
              <input type="checkbox" name="is_direct_withdrawal" class="custom-control-input" [(ngModel)]="tax.is_direct_withdrawal" [checked]="tax.is_direct_withdrawal" />
              <label class="custom-control-label">Direct Withdrawal</label>
            </div>
            <br />
            <div class="custom-control custom-checkbox" (click)="tax.is_factor = !tax.is_factor">
              <input type="checkbox" name="is_factor" class="custom-control-input" [(ngModel)]="tax.is_factor" [checked]="tax.is_factor" />
              <label class="custom-control-label">Include In Factors? (if Expense Tax)</label>
            </div>
            <br />
            <div class="custom-control custom-checkbox" (click)="tax.is_before_health_deduction = !tax.is_before_health_deduction">
              <input type="checkbox" name="is_before_health_deduction" class="custom-control-input" [(ngModel)]="tax.is_before_health_deduction" [checked]="tax.is_before_health_deduction" />
              <label class="custom-control-label">Before Health Deduction</label>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col text-center">
            <button type="button" class="btn btn-primary" [disabled]="formSubmitting" (click)="save(currentForm.form.valid)">
              {{ formSubmitting ? 'Saving' : 'Save' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
            >&nbsp;
            <button type="button" class="btn btn-secondary" [disabled]="formSubmitting" (click)="back()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
